// useLocalUserData.js
import { useState, useEffect } from "react";

export function useLocalUserData(key) {
  const [data, setData] = useState({});

  useEffect(() => {
    const storedValue = localStorage.getItem(key);
    try {
      const parsed = JSON.parse(storedValue);
      setData(parsed ?? {});
    } catch {
      setData(storedValue ? { value: storedValue } : {});
    }
  }, [key]);

  return data;
}
